import { forwardRef } from 'react';

import { Drawer as DrawerPrimitive } from 'vaul';

import Close from '@/icons/close.svg';
import { cn } from '@/utils';

function Drawer({ shouldScaleBackground = true, ...props }) {
	return (
		<DrawerPrimitive.Root
			shouldScaleBackground={shouldScaleBackground}
			{...props}
		/>
	);
}
Drawer.displayName = 'Drawer';

const DrawerTrigger = DrawerPrimitive.Trigger;

const DrawerPortal = DrawerPrimitive.Portal;

const DrawerClose = DrawerPrimitive.Close;

const DrawerOverlay = forwardRef(({ className, ...props }, ref) => (
	<DrawerPrimitive.Overlay
		ref={ref}
		className={cn('fixed inset-0 z-50 bg-black/30', className)}
		{...props}
	/>
));
DrawerOverlay.displayName = DrawerPrimitive.Overlay.displayName;

function DrawerCloseButton() {
	return (
		<DrawerPrimitive.Close className="absolute right-4 top-2 flex size-8 items-center justify-center rounded-sm transition-colors hover:bg-grey-100 active:bg-grey-200 disabled:pointer-events-none">
			<Close className="h-5 w-5 text-black" />
			<span className="sr-only">Close</span>
		</DrawerPrimitive.Close>
	);
}

const DrawerContent = forwardRef(
	({ className, children, hasCross, ...props }, ref) => (
		<DrawerPortal>
			<DrawerOverlay />
			<DrawerPrimitive.Content
				ref={ref}
				className={cn(
					'fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-tl-lg rounded-tr-lg border border-grey-200 bg-background shadow-[0px_4px_12px_4px_rgba(22,22,25,0.06)] shadow-[0px_4px_6px_2px_rgba(22,22,25,0.03)]',
					className
				)}
				{...props}
			>
				{children}
				{hasCross && <DrawerCloseButton />}
			</DrawerPrimitive.Content>
		</DrawerPortal>
	)
);
DrawerContent.displayName = 'DrawerContent';

function DrawerHeader({ className, ...props }) {
	return (
		<div
			className={cn('grid gap-1.5 p-4 text-center sm:text-left', className)}
			{...props}
		/>
	);
}
DrawerHeader.displayName = 'DrawerHeader';

function DrawerFooter({ className, ...props }) {
	return (
		<div
			className={cn('mt-auto flex flex-col gap-2 p-4', className)}
			{...props}
		/>
	);
}
DrawerFooter.displayName = 'DrawerFooter';

const DrawerTitle = forwardRef(({ className, ...props }, ref) => (
	<DrawerPrimitive.Title
		ref={ref}
		className={cn(
			'text-lg font-semibold leading-none tracking-tight',
			className
		)}
		{...props}
	/>
));
DrawerTitle.displayName = DrawerPrimitive.Title.displayName;

const DrawerDescription = forwardRef(({ className, ...props }, ref) => (
	<DrawerPrimitive.Description
		ref={ref}
		className={cn('text-sm', className)}
		{...props}
	/>
));
DrawerDescription.displayName = DrawerPrimitive.Description.displayName;

export {
	Drawer,
	DrawerPortal,
	DrawerOverlay,
	DrawerTrigger,
	DrawerClose,
	DrawerContent,
	DrawerHeader,
	DrawerFooter,
	DrawerTitle,
	DrawerDescription
};
